import { CabecalhoIO } from './Cabecalho.IO'
import { FormControl, Grid, MenuItem, Select } from '@material-ui/core'
import { IOProps } from 'react-compose-io'
import CloseIcon from '@material-ui/icons/Close'
import FilterIcon from '../../../../assets/icons/filter-icon-branco.svg'
import { Tipografia } from './../../../../components/Tipografia/index'
import { corParceiroId } from '../../../../styles/customTheme'
import { ModalFiltroParceiro } from '../../../../components/ModalFiltroParceiro'
import { Controller } from 'react-hook-form'
import { Botao } from './../../../../components/Botao/index'

export type CabecalhoProps = {
  parceiroSelecionado: number
  handleClickMes: (mesSelecionado: 6 | 3) => void
  handleClickParceiro: (parceiroId: number) => void
}

export function CabecalhoView({ _io, parceiroSelecionado, handleClickParceiro }: IOProps<CabecalhoIO, CabecalhoProps>) {
  const { Avatar, Chip, ContainerFormTitulo, Form } = _io.styles

  return (
    <header>
      <Grid container spacing={2} justifyContent="space-between" alignItems="center" direction="row">
        <Grid item>
          <ContainerFormTitulo>
            <Tipografia variant="h5">Controle de classificações</Tipografia>
            {Boolean(parceiroSelecionado) && _io.parceiros.length > 0 && (
              <Chip
                icon={<Avatar src={_io.parceiros.filter((x) => x.parceiroId === parceiroSelecionado)[0].logoUrl} />}
                label={_io.parceiros.filter((x) => x.parceiroId === parceiroSelecionado)[0].nomeFantasia}
                onDelete={() => _io.handleFecharChip()}
                deleteIcon={<CloseIcon />}
                variant="outlined"
                cor={corParceiroId.get(parceiroSelecionado)}
              />
            )}
            <Form>
              <Controller
                render={({ field }) => (
                  <FormControl variant="standard" size="small" fullWidth>
                    <Select {...field} label="meses">
                      <MenuItem value={6}>Últimos 6 meses</MenuItem>
                      <MenuItem value={3}>Últimos 3 meses</MenuItem>
                    </Select>
                  </FormControl>
                )}
                name="meses"
                control={_io.control}
              />
            </Form>
          </ContainerFormTitulo>
        </Grid>
        <Grid item>
          <Botao
            textoBotao={'Filtrar por parceiro'}
            cor="primaria"
            estilo="contained"
            type="submit"
            startIcon={<img src={FilterIcon} />}
            onClick={() => _io.setAbrirModalFiltroParceiros(true)}
          />
        </Grid>
      </Grid>
      <ModalFiltroParceiro
        descricaoModal={`A visualização de histórico de perdas pode ser feita por parceiro.`}
        isShow={_io.abrirModalFiltroParceiros}
        isClosed={() => _io.setAbrirModalFiltroParceiros(false)}
        handleClickParceiro={handleClickParceiro}
        parceiros={_io.parceiros}
      />
    </header>
  )
}
